import { PropsWithChildren } from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@leadsnavi/ui-kit';
import cn from 'classnames';

interface MenuIconProps extends PropsWithChildren {
  title?: string;
  onClick?: () => void;
  className?: string;
  isActive?: boolean;
}
export default function MenuIcon(props: MenuIconProps) {
  if (props.title) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn('px-3 flex justify-center mt-2', props.className || '')}>
            <div
              className={cn('p-1.5 cursor-pointer hover:bg-[#E5E5E5]/45 rounded transition', {
                'bg-[#E5E5E5]/65': props.isActive,
              })}
              onClick={props.onClick}
            >
              {props.children}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">{props.title}</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <div className={cn('px-3 flex justify-center mt-2', props.className || '')}>
      <div
        className={cn('p-1.5 cursor-pointer hover:bg-[#E5E5E5]/45 rounded transition', {
          'bg-[#E5E5E5]/65': props.isActive,
        })}
        onClick={props.onClick}
      >
        {props.children}
      </div>
    </div>
  );
}
